import throttle from "lodash/throttle"
import colors from "foundation/_colors_export.scss?export"

export default function SwapBGColorsBelowElement(
  selector,
  topColor = colors.primaryTextColor,
  bottomColor = colors.primaryBackgroundColor
) {
  const element = document.querySelector(selector)
  if (!element) return

  const body = document.querySelector("body")
  let rect = element.getBoundingClientRect()
  let scrollBelowThreshold =
    rect.top + rect.height + (window.scrollY || window.pageYOffset)
  let bgColor = topColor

  const swapColors = color => {
    if (color !== bgColor) body.style.backgroundColor = bgColor = color
  }

  const onScrollSwapBG = throttle(() => {
    if (scrollBelowThreshold < (window.scrollY || window.pageYOffset)) {
      swapColors(bottomColor)
    } else {
      swapColors(topColor)
    }
  }, 150)

  const onResize = throttle(() => {
    rect = element.getBoundingClientRect()
    scrollBelowThreshold =
      rect.top + rect.height + (window.scrollY || window.pageYOffset)
  }, 500)

  window.addEventListener("resize", onResize)
  window.addEventListener("scroll", onScrollSwapBG, { passive: true })
}
